var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'item-container ' + _vm.brandName},[_c('h1',[_vm._v(_vm._s(_vm.item.header))]),_c('a',{staticClass:"btn",attrs:{"href":_vm.item.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.item.btnText))])])}
var staticRenderFns = []

export { render, staticRenderFns }